import { RevenueReportPropertise } from "../Models/RevenueManagementProperties";
import * as XLSX from 'xlsx';
import { Component, ViewChild } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import {
  RevenueManagementBaseData, RevenueManagementAirlineCodes, RevenueManagementAirports,
  RevenueManagementProperties, RevenueManagementCalculationFlight,
  Supplier_OficeID,
  RevenueManagementSupplierFlights,
  RevenueManagementFlightLocationProperties,
  RevenueManagement_AirlineFlight, AirlineControlType
} from "../Models/RevenueManagementProperties";
import { AfterViewInit, ElementRef } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RevenueManagementService } from "../Services/revenue-management.service";
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http'
import { Router } from "@angular/router";
import { ActiveSuppliers, Agency_Branches } from "../Models/ActiveClasses";
import { NgSelectComponent } from "@ng-select/ng-select";
import { createBreak } from "typescript";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TicketPnrRights } from "../Models/TicketIssuanceProperties";
import { TicketIssuanceService } from "../Services/ticketIssuance.service";
import { MessageService } from "primeng/api";
import { Countries } from '../Models/Countries';
declare var $;

@Component({
  selector: 'app-revenue-management',
  templateUrl: './revenue-management.component.html',
  styleUrls: ['./revenue-management.component.css']
})
/** RevenueManagement component*/
export class RevenueManagementComponent {
  //angForm: FormGroup;
  constructor(public revenueService: RevenueManagementService, private http: HttpClient, private FallSuccess: NgbModal,

    private router: Router, private messageservice: MessageService) { }
  @ViewChild('oficeId', { static: false }) ddlOficeId: NgSelectComponent;
  @ViewChild('agency_brancch', { static: false }) ddlAgency_branch: NgSelectComponent;
  @ViewChild('supplier', { static: false }) ddlSupplier: NgSelectComponent;
  @ViewChild('airportFrom', { static: false }) fromAirport: NgSelectComponent;
  @ViewChild('airportTo', { static: false }) toAirport: NgSelectComponent;
  @ViewChild('btnCancel', { static: false }) cancelButton!: ElementRef<HTMLButtonElement>;
  data: any; //Adeel
  fileName: string; //Adeel
  file: File | null = null; //Adeel
  message: string = '';
  reuiredValidate: boolean;
  revenueObj = new RevenueManagementProperties();
  allBaseData$: RevenueManagementBaseData;
  revenueData$: RevenueManagementProperties;
  agency_branchesList$: Observable<Agency_Branches[]>;
  supplierList$: Observable<ActiveSuppliers[]>;
  activeSuppliers: ActiveSuppliers[] = [];
  airportsList$: Observable<RevenueManagementAirports[]>;
  airlineList$: Observable<RevenueManagementAirlineCodes[]>;
  countryList: Countries[] = [];
  selectedFromCountry: string;
  selectedToCountry: string; 
  oficeIdList$: Observable<Supplier_OficeID[]>;
  supplier_oficeIdData: Supplier_OficeID[] = [];
  flightCalculations: RevenueManagementCalculationFlight[] = [];
  selectedSuppliers: string[] = [];
  showAirline: boolean = false;
  selectedOficeIds: string[] = [];
  selectedFromLocation: string[] = [];
  selectedToLocation: string[] = [];
  selectedVIALocation: string[] = [];
  selectedValidatingAirline: string[] = [];
  selectedMarkitingAirline: string[] = [];
  selectedOperatingAirline: string[] = [];
  //originalAirlines: RevenueManagementAirlineCodes[] = [];
  //originalAirports: RevenueManagementAirports[] = [];
  saveData = false;
  excludedFromLocation: string[] = [];
  excludedToLocation: string[] = [];
  excludedVIALocation: string[] = [];
  buttonName: string = "Save";
  passengerTypeList = [
    { type: "ADT" },
    { type: "CHD" },
    { type: "INF" },
  ];
  cabinClassList = [
    { cabinType: "FirstClass" },
    { cabinType: "Business" },
    { cabinType: "Economy" },
    { cabinType: "PremiumEconomy" },
    { cabinType: "ALL" },
    //{ cabinType: "Economy Class" },
  ];
  rbdList = [
    { rbdType: "A" },
    { rbdType: "B" },
    { rbdType: "C" },
    { rbdType: "D " },
    { rbdType: "E" },
    { rbdType: "F" },
    { rbdType: "G" },
    { rbdType: "H" },
    { rbdType: "I" },
    { rbdType: "J" },
    { rbdType: "K" },
    { rbdType: "L" },
    { rbdType: "M" },
    { rbdType: "N" },
    { rbdType: "O" },
    { rbdType: "P" },
    { rbdType: "Q" },
    { rbdType: "R" },
    { rbdType: "S" },
    { rbdType: "T" },
    { rbdType: "U" },
    { rbdType: "V" },
    { rbdType: "W" },
    { rbdType: "X" },
    { rbdType: "Y" },
    { rbdType: "Z" },
    { rbdType: "ALL" },

  ];

  calculatedOnList = [
    { calculateType: "Base Fare" },
    { calculateType: "Total Fare" },
  ];

  ddlTypeList = [
    { item: "Agency", id: 1 },
    { item: "Branch", id: 2 },
    { item: "All", id: 3 },
    //{ item: "Group", id: 3 },
  ];
  /*=====Form Validation====*/
  //createForm() {
  //  this.angForm = this.fb.group({
  //   // travelto: ['', Validators.required],
  //   // bookingto: ['', Validators.required]
  //  })
  //}

  //angForm = new FormGroup({
  //  travelto:new FormControl('', Validators.required),
  ////bookingto: ['', Validators.required]
  //})

  /*=====Type Section====*/
  isMarkup = false;
  isDiscount = false;
  isServiceFee = false;
  isCommission = false;
  isRefund = false;
  isReissue = false;
  isAirlineCommission = false;

  //End

  // 05-oct-23
  showDiscountTypes = false;
  //end

  /*=====Applies On====*/
  isPassenger = false;
  isPNR = false;
  //End

  // CheckRevenueManagementRights() {
  //   this.revenueService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
  //     if (data) {

  //       $("#btnSave").removeAttr("disabled");
  //     }
  //     else {
  //       $("#btnSave").attr("disabled", "disabled");
  //     }
  //   });
  // }

  minDate: string = "";
  minDateto: string = "";
  refundRevenue: boolean = false;
  voidRevenue: boolean = false;
  ticketRevenue: boolean = false;
  importRevenue: boolean = false;
  revenuetype: string = "";
  showCountryDropdown: boolean = false;
  canEditOrAddRevenue:boolean = true;
  ngOnInit() {
    this.CheckCanEditRevenueRights();
    this.revenuetype = localStorage.getItem("RevenueType");
    if (this.revenuetype == "Ticket") {
      this.ticketRevenue = true;
    }
    else if (this.revenuetype == "Void") {
      this.voidRevenue = true;
    }
    else if (this.revenuetype == "Refund") {
      this.refundRevenue = true;
    }
    else if (this.revenuetype == "ImportPNR") {
      this.importRevenue = true;
    }
    if ((localStorage.getItem("isFromAgencyList")) == null || (localStorage.getItem("isFromAgencyList")) == undefined)
      document.getElementById("isFromAgencyList").style.padding = "20px 80px 10px 80px";     //style="padding:20px 80px 10px 80px;
    else
      localStorage.removeItem("isFromAgencyList");


    this.revenueService.GetRevenueManagementAgencies_Branches(localStorage.getItem("AgencyId")).subscribe((data) => {
      //data.push(localStorage.getItem("AgencyId"))
      this.agency_branchesList$ = of(data);
      this.AddFlightCalculation();
      this.GetRevenueBaseData();
      this.revenueObj.isOficeId = true;
      const today = new Date();
      this.minDate = today.toISOString().split('T')[0];
      // this.CheckRevenueManagementRights();
      this.isPNR = false;
      if(this.revenueObj.groupRevenueName.length > 0){
        this.isReadOnly = true;
      }

    })
    this.LoadGroupRevenue();


  }
  GroupRevenue: RevenueReportPropertise[] = [];
  GroupNameList: string[] = []
  LoadGroupRevenue(){
    this.revenueService.GetGroupRevenueReport().subscribe(data => {
      if(data != null){
        console.log(data);
        this.GroupRevenue = data;
        for(let i = 0; i < data.length; i++){
          this.GroupNameList.push(this.GroupRevenue[i].groupName);
        }
      }
    })
  }

  isReadOnly: boolean = false;
  agencyCodeList: any;
  GroupRevenueData: RevenueReportPropertise[] = [];
  ChangeGroupRevenue(a){
    this.GroupRevenueData = [];
    if(a != null){
      this.revenueService.GetGroupRevenue(a).subscribe(data =>{
        if(data != null){
          this.GroupRevenueData.push(data);
          console.log("Latest", this.GroupRevenueData);
          this.revenueObj.agencyBranchList = this.GroupRevenueData[0].agencyCodeList;
       /*   this.revenueObj.groupRevenueName = data.groupName;*/
          this.isReadOnly = true;

          try {
            this.ddlSupplier.handleClearClick();
            if (this.revenueObj.agencyBranchList.length == 1) {
      
              this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((data) => {
                this.supplierList$ = of(data);
      
              })
            }
            else {
              this.revenueService.GetRevenueManagementSupplierAll().subscribe((data) => {
                this.supplierList$ = of(data);
      
              })
            }
          }
          catch (e) {
      
          }
        }
      })
    }
    else{
      this.isReadOnly = false;
      this.revenueObj.agencyBranchList = [];
    }
  }


  GetRevenueBaseData() {
    try {
      this.revenueService.GetRevenueBaseData().subscribe((data) => {
        this.allBaseData$ = data;
        /* this.originalAirlines = this.allBaseData$.airlines;*/
        this.airlineList$ = of(this.allBaseData$.airlines);
        let airport = new RevenueManagementAirports();
        airport.cityName = "World Wide";
        airport.iATA_CODE = "World Wide";
        this.allBaseData$.airports.push(airport);
        this.countryList = this.allBaseData$.countries;
        this.countryList.push({
          countryId: 0,
          countryName: 'World Wide',
          code: 'WWW',
          status: true,
          isDeleted: false,
          creationUser: 0,
          countryAccessCode: '',
          flagsImages: '',
          mobileNoLength: 0,
          cityName: ''
        });
        /*this.originalAirports = this.allBaseData$.airports;*/
        this.airportsList$ = of(this.allBaseData$.airports);
        if ((localStorage.getItem("RevenueManagementListId") != undefined) && (localStorage.getItem("RevenueManagementListId") != "")) {
          let revenueId = localStorage.getItem("RevenueManagementListId");
          this.buttonName = "Update";
          localStorage.removeItem("RevenueManagementListId");
          this.revenueService.GetRevenueById(revenueId).subscribe((data) => {
            this.revenueObj = data;

            if (this.revenueObj != null && this.revenueObj != undefined) {
              
              /*this.revenueObj.travelDateFrom = this.revenueObj.travelDateFrom.split(' ')[0];*/
              //this.revenueObj.travelDateTo = this.revenueObj.travelDateTo.split(' ')[0];
              //this.revenueObj.bookingDateFrom = this.revenueObj.bookingDateFrom.split(' ')[0];
              //this.revenueObj.bookingDateTo = this.revenueObj.bookingDateTo.split(' ')[0];
              for (let i = 0; i < this.revenueObj.agencyBranchList.length; i++) {
                if (this.revenueObj.agencyBranchList[i] == "AG01") {
                  this.showAirline = true;
                }
                else {
                  this.showAirline = false;

                }
              }
              this.ChangeType(this.revenueObj.type);
              this.ChangeAppliesOn(this.revenueObj.appliesOn);
              this.BindDropdowns(this.revenueObj);
              //this.revenueObj.agencyId_BranchId = data.agencyId_BranchId;
            }
          })
        }

      })
    }
    catch (e) {

    }
  }
  //SelectionChange(type) {
  //  try {
  //    this.ddlAgency_branch.handleClearClick();
  //    this.revenueService.GetRevenueManagementAgencies_Branches(localStorage.getItem("AgencyId"), type).subscribe((data) => {
  //      //data.push(localStorage.getItem("AgencyId"))
  //      this.agency_branchesList$ = of(data);

  //    })
  //  }
  //  catch (e) {

  //  }
  //}

  // This method is used to check the rights of user for edit or add the revenue management and those who have this right will be able to edit or add the revenues;
  CheckCanEditRevenueRights() {
    this.revenueService.canEditRevenue(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      this.canEditOrAddRevenue = data;
    });
  }


  BindDropdowns(obj: RevenueManagementProperties) {
    try {
      let agency_branch = obj.agencyId_BranchId;
      this.ddlAgency_branch.handleClearClick();
      obj.agencyId_BranchId = agency_branch;
      this.revenueService.GetRevenueManagementAgencies_Branches(localStorage.getItem("AgencyId")).subscribe((data) => {
        this.agency_branchesList$ = of(data);
      })
      
      this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((result) => {
        this.ddlSupplier.handleClearClick();
        this.activeSuppliers = result;
        this.supplierList$ = of(result);
        this.revenueObj.selectedSuppliersList = [];
        for (let i = 0; i < this.activeSuppliers.length; i++) {
          let mainList = this.activeSuppliers[i];
          for (let j = 0; j < this.revenueObj.suppliersData.length; j++) {
            let listItem = this.revenueObj.suppliersData[j];
            if (mainList.supplierId == listItem.supplierId) {


              this.revenueObj.selectedSuppliersList.push(listItem.supplierId);

              break;
            }
          }
        }
        if (this.revenueObj.selectedSuppliersList.length > 0) {

          this.showCountryDropdown = this.revenueObj.selectedSuppliersList.includes('SPB_031');
          if (this.showCountryDropdown) {
            this.selectedFromCountry = this.revenueObj.flightLocationCountryForInsurance.fromCountryCode;
            this.selectedToCountry = this.revenueObj.flightLocationCountryForInsurance.toCountryCode;
          }
          this.revenueService.GetRevenueManagementOficeIds(this.revenueObj.selectedSuppliersList.toString()).subscribe((oficeIdData) => {
            this.oficeIdList$ = of(oficeIdData);
            this.supplier_oficeIdData = oficeIdData;
            this.revenueObj.selectedOficeIdsList = [];
            for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
              let mainList = this.supplier_oficeIdData[i];
              for (let j = 0; j < this.revenueObj.suppliersData.length; j++) {
                let listItem = this.revenueObj.suppliersData[j];
                if (mainList.officeId == listItem.officeId &&
                  mainList.supplierId == listItem.supplierId) {
                  let str = listItem.officeId + "-" + listItem.supplierId;
                  this.revenueObj.selectedOficeIdsList.push(str);
                  break;
                }
              }
            }
          })
        }

      })
      this.selectedFromLocation = [];
      this.selectedToLocation = [];
      if (this.revenueObj.flightLocationDataIncluded.length > 0) {
        this.selectedFromLocation = [...new Set(this.revenueObj.flightLocationDataIncluded.map(x => x.fromLocation))]
        this.selectedToLocation = [...new Set(this.revenueObj.flightLocationDataIncluded.map(x => x.toLocation))]
        this.selectedVIALocation = [...new Set(this.revenueObj.flightLocationDataIncluded.map(x => x.viaLocation))]
      }

      if (this.revenueObj.flightLocationDataExcluded.length > 0) {
        this.excludedFromLocation = [...new Set(this.revenueObj.flightLocationDataExcluded.map(x => x.fromLocation))]
        this.excludedToLocation = [...new Set(this.revenueObj.flightLocationDataExcluded.map(x => x.toLocation))]
        this.excludedVIALocation = [...new Set(this.revenueObj.flightLocationDataExcluded.map(x => x.viaLocation))]
      }
      this.selectedValidatingAirline = [];
      this.selectedMarkitingAirline = [];
      this.selectedOperatingAirline = [];
      this.revenueObj.selectedValidatingAirlineList = [];
      for (let j = 0; j < this.revenueObj.airlineFlightData.length; j++) {
        let listItem = this.revenueObj.airlineFlightData[j];
        if (listItem.airlineTypeId == 1) {
          this.selectedValidatingAirline.push(listItem.airlineId);
          this.revenueObj.selectedValidatingAirlineList.push(listItem.airlineId);
        }
        else if (listItem.airlineTypeId == 2)
          this.selectedMarkitingAirline.push(listItem.airlineId);
        else if (listItem.airlineTypeId == 3)
          this.selectedOperatingAirline.push(listItem.airlineId);
      }
      if (this.revenueObj.flightCalaculationData.length > 0) {
        this.flightCalculations = [];
        for (let j = 0; j < this.revenueObj.flightCalaculationData.length; j++) {
          let listItem = this.revenueObj.flightCalaculationData[j];
          listItem.selectedRbd = [];
          listItem.selectedRbd = listItem.rbd.split(',');
          this.flightCalculations.push(listItem);
        }
      }


    }
    catch (e) {

    }
  }




  ChangeAgency_Branch(agency_branch) {
    if (agency_branch.length == 0) {
      this.showAirline = false;
      this.isAirlineCommission = false;
      this.applychilddisable = false;
      this.applychildbranchdisable = false;
    }
    for (let i = 0; i < agency_branch.length; i++) {
      if (agency_branch[i] == "AG01") {
        this.showAirline = true;
      }
      else {
        this.showAirline = false;

      }
    }

    try {
      this.ddlSupplier.handleClearClick();
      if (agency_branch.length == 1) {

        this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((data) => {
          this.supplierList$ = of(data);

        })
      }
      else {
        this.revenueService.GetRevenueManagementSupplierAll().subscribe((data) => {
          this.supplierList$ = of(data);

        })
      }
    }
    catch (e) {

    }
  }

  ChangeSupplier(selectedList) {
    try {
      if (selectedList.length > 0) {
        /*        this.ddlOficeId.handleClearClick();*/
        this.showCountryDropdown = selectedList.includes('SPB_031');
        let str = selectedList.toString();
        this.revenueService.GetRevenueManagementOficeIds(str).subscribe((data) => {
          this.oficeIdList$ = of(data);
          console.log(this.oficeIdList$);
          this.supplier_oficeIdData = data;
          this.revenueObj.selectedOficeIdsList = [];
        })
      }
      else {
        this.revenueObj.selectedOficeIdsList = [];
        this.showCountryDropdown = false;
     /*   this.ddlOficeId.handleClearClick();*/
        this.oficeIdList$ = of([]);
      }
    }
    catch (e) {

    }
  }
  applychilddisable: boolean = false;
  applychildbranchdisable: boolean = false;
  ChangeType(typeValue) {
    try {
      if (typeValue == "Markup") {
        this.isMarkup = true;
        this.isDiscount = false;
        this.isServiceFee = false;
        this.isCommission = false;
        this.isRefund = false;
        this.isReissue = false;
        this.isAirlineCommission = false;
        this.revenueObj.type = "Markup"
        this.applychildbranchdisable = false;
        this.applychilddisable = false;
      }
      else if (typeValue == "Discount") {
        this.isMarkup = false;
        this.isDiscount = true;
        this.isServiceFee = false;
        this.isCommission = false;
        this.isRefund = false;
        this.isReissue = false;
        this.isAirlineCommission = false;
        this.revenueObj.type = "Discount"
        this.applychildbranchdisable = false;
        this.applychilddisable = false;


      }
      else if (typeValue == "ServiceFee") {
        this.isMarkup = false;
        this.isDiscount = false;
        this.isServiceFee = true;
        this.isCommission = false;
        this.isRefund = false;
        this.isReissue = false;
        this.isAirlineCommission = false;
        this.revenueObj.type = "ServiceFee"
        this.applychildbranchdisable = false;
        this.applychilddisable = false;
      }
      else if (typeValue == "Commission") {
        this.isMarkup = false;
        this.isDiscount = false;
        this.isServiceFee = false;
        this.isCommission = true;
        this.isRefund = false;
        this.isReissue = false;
        this.isAirlineCommission = false;
        this.revenueObj.type = "Commission"
        this.applychildbranchdisable = false;
        this.applychilddisable = false;
      }
      else if (typeValue == "Refund") {
        this.isMarkup = false;
        this.isDiscount = false;
        this.isServiceFee = false;
        this.isCommission = false;
        this.isRefund = true;
        this.isReissue = false;
        this.isAirlineCommission = false;
        this.revenueObj.type = "Refund"
        this.applychildbranchdisable = false;
        this.applychilddisable = false;
      }
      else if (typeValue == "Reissue") {
        this.isMarkup = false;
        this.isDiscount = false;
        this.isServiceFee = false;
        this.isCommission = false;
        this.isRefund = false;
        this.isReissue = true;
        this.isAirlineCommission = false;
        this.revenueObj.type = "Reissue"
        this.applychildbranchdisable = false;
        this.applychilddisable = false;
      }
      else if (typeValue == "AirlineCommission") {
        this.isMarkup = false;
        this.isDiscount = false;
        this.isServiceFee = false;
        this.isCommission = false;
        this.isRefund = false;
        this.isReissue = false;
        this.isAirlineCommission = true;
        this.applychildbranchdisable = true;
        this.applychilddisable = true;
        this.revenueObj.applyChildAgency = false;
        this.revenueObj.applyChildBranches = false;
        this.revenueObj.type = "AirlineCommission"

      }
      else {
        this.isMarkup = false;
        this.isDiscount = false;
        this.isServiceFee = false;
        this.isCommission = false;
        this.isRefund = false;
        this.isReissue = false;
        this.isAirlineCommission = false;
        this.revenueObj.type = "";
        this.applychildbranchdisable = false;
        this.applychilddisable = false;

      }
      // 05-oct-23
      if (this.isDiscount == true) {
        this.showDiscountTypes = true;
      }
      else {
        this.revenueObj.isDiscountSupplierCommission=false;
        this.revenueObj.isRegularDiscount=false;
        this.showDiscountTypes = false;
      }
      //end



    }
    catch (e) {

    }
  }
  ChangeAppliesOn(appliesValue) {
    try {
      if (appliesValue == "Passenger") {
        this.isPassenger = true;
        this.isPNR = false;
        this.revenueObj.appliesOn = "Passenger"
      }
      else if (appliesValue == "PNR") {
        this.isPassenger = false;
        this.isPNR = true;
        this.revenueObj.appliesOn = "PNR"
      }
      else {
        this.isPassenger = false;
        this.isPNR = false;
        this.revenueObj.appliesOn = ""
      }
    }
    catch (e) {

    }
  }
  ChangeDirection(e) {
    try {
      let value = e.target.value;
      let checked = e.target.checked;
      if (value == "OneWay") {
        this.revenueObj.oneWayDirection = checked;
      }
      if (value == "RoundTrip") {
        this.revenueObj.roundTripDirection = checked;
      }
      if (value == "MultiCity") {
        this.revenueObj.multiTripDirection = checked;
      }
      this.revenueObj.isDirection = this.revenueObj.oneWayDirection || this.revenueObj.roundTripDirection || this.revenueObj.multiTripDirection;
    }
    catch (e) {

    }
  }

  AddFlightCalculation() {
    try {
      if (this.flightCalculations.length == 0) {
        let obj = new RevenueManagementCalculationFlight();
        this.flightCalculations.push(obj);
      }

      else {
        if (this.flightCalculations[this.flightCalculations.length - 1].passengerType != null && this.flightCalculations[this.flightCalculations.length - 1].passengerType != undefined && this.flightCalculations[this.flightCalculations.length - 1].passengerType.length>0) {
          if (this.flightCalculations[this.flightCalculations.length - 1].cabinClass != null && this.flightCalculations[this.flightCalculations.length - 1].cabinClass != undefined && this.flightCalculations[this.flightCalculations.length - 1].cabinClass != "") {
            let obj = new RevenueManagementCalculationFlight();
            this.flightCalculations.push(obj);
          }
          else {
            document.getElementById(`messageclascbi${this.flightCalculations.length - 1}`).innerHTML = "Required";
            document.getElementById(`cabintypes${this.flightCalculations.length - 1}`).classList.add("newRequired-BoxColor");

            setTimeout(() => {
              document.getElementById(`messageclascbi${this.flightCalculations.length - 1}`).innerHTML = "";
              document.getElementById(`cabintypes${this.flightCalculations.length - 1}`).classList.remove("newRequired-BoxColor");

            }, 3000);
            return;
          }
        }
        else {
          document.getElementById(`messagetypess${this.flightCalculations.length - 1}`).innerHTML = "Required";
          document.getElementById(`pastyps${this.flightCalculations.length - 1}`).classList.add("newRequired-BoxColor");

          setTimeout(() => {
            document.getElementById(`messagetypess${this.flightCalculations.length - 1}`).innerHTML = "";
            document.getElementById(`pastyps${this.flightCalculations.length - 1}`).classList.remove("newRequired-BoxColor");

          }, 3000);
          return;
        }

      }

    }
    catch (e) {
    }
  }
  DeleteFlightCalculation(index) {
    try {
      this.flightCalculations.splice(index, 1);
    }
    catch (e) {
    }
  }
  clearcabinrbd(i) {

    this.flightCalculations[i].selectedRbd = [];
  }

  //FromAirportChange(selectedValues) {
  //  try {
  //    for (let i = 0; i < selectedValues.length; i++) {

  //      if (selectedValues[i] !== "") {
  //        this.revenueObj.isLocation = true;
  //      }
  //      if (selectedValues[i] == null) {
  //        this.revenueObj.isLocation = false;
  //      }
  //      if (selectedValues[i] == "World Wide") {
  //        this.selectedFromLocation = [];
  //        //this.fromAirport.handleClearClick();
  //        this.selectedFromLocation.push("World Wide");
  //        break;
  //      }
  //     // //console.log(selectedValues[i]);
  //    }

  //  }
  //  catch (e) {

  //  }

  //  //if (selectedValues.target.value == "") {
  //  //  this.revenueObj.isLocation = false;
  //  //} else if (selectedValues.target.value) {
  //  //  this.revenueObj.isLocation = true;
  //  //}
  //}

  FromAirportChange(selectedValues) {
    try {
      for (let i = 0; i < selectedValues.length; i++) {

        if (selectedValues[i] == "World Wide") {
          this.selectedFromLocation = [];
          //this.fromAirport.handleClearClick();
          this.selectedFromLocation.push("World Wide");
          break;
        }
        // //console.log(selectedValues[i]);
      }

      if (this.selectedFromLocation.length != 0) {
        this.revenueObj.isLocation = true;
      }
      if (this.selectedFromLocation.length <= 0 || this.selectedFromLocation.length == undefined) {
        this.revenueObj.isLocation = false;
      }


    }
    catch (e) {

    }

  }

  ToAirportChange(selectedValues) {
    try {
      for (let i = 0; i < selectedValues.length; i++) {
        if (selectedValues[i] == "World Wide") {
          this.selectedToLocation = [];
          //this.fromAirport.handleClearClick();
          this.selectedToLocation.push("World Wide");
          break;
        }
      }
    }
    catch (e) {

    }
  }




  //CheckValidations(): boolean {
  //  try {
  //    if (this.revenueObj.selectedSuppliersList != undefined) {
  //      if (this.revenueObj.type == "" || this.revenueObj.name == "" || this.revenueObj.agencyId_BranchId == ""
  //        || (this.revenueObj.selectedSuppliersList.length == 0)) {
  //        this.saveData = false;
  //        $("#requirefldmsg").show();
  //        document.getElementById("requirefldmsg").innerHTML = "Please Select Suppliers."
  //        $("#requirefldmsg").delay(2000).hide(1000);
  //        return false;
  //      }
  //    }
  //    if (this.revenueObj.travelDateFrom.length > 0 && this.revenueObj.travelDateTo == "") {
  //      this.saveData = false;
  //      $("#requirefldmsg").show();
  //      document.getElementById("requirefldmsg").innerHTML = "Please Select Travel Dates."
  //      $("#requirefldmsg").delay(2000).hide(1000);
  //      return false;
  //    }
  //    if (this.revenueObj.bookingDateFrom.length > 0 && this.revenueObj.bookingDateTo == "") {
  //      this.saveData = false;
  //      $("#requirefldmsg").show();
  //      document.getElementById("requirefldmsg").innerHTML = "Please Select Booking Dates."
  //      $("#requirefldmsg").delay(2000).hide(1000);
  //      return false;
  //    }
  //    if (this.selectedFromLocation.length > 0 && this.selectedToLocation.length == 0) {
  //      this.saveData = false;
  //      $("#requirefldmsg").show();
  //      document.getElementById("requirefldmsg").innerHTML = "Please Select To and From Location."
  //      $("#requirefldmsg").delay(2000).hide(1000);
  //      return false;
  //    }
  //    if (this.flightCalculations.length < 1
  //      || this.flightCalculations.length == null) {
  //      this.saveData = false;
  //      $("#requirefldmsg").show();
  //      document.getElementById("requirefldmsg").innerHTML = "Please Enter Calculation Data"
  //      $("#requirefldmsg").delay(2000).hide(1000);
  //      return false;
  //    }
  //    for (let i = 0; i < this.flightCalculations.length; i++) {
  //      if (this.flightCalculations[i].cabinClass == "" || this.flightCalculations[i].cabinClass == null
  //        || this.flightCalculations[i].calculatedOn == "" || this.flightCalculations[i].calculatedOn == null
  //        || this.flightCalculations[i].passengerType == "" || this.flightCalculations[i].passengerType == null
  //        || this.flightCalculations[i].selectedRbd.length < 1 || this.flightCalculations[i].selectedRbd.length == null
  //        || (this.flightCalculations[i].valueAmount == 0 && this.flightCalculations[i].valuePercent == 0)) {
  //        this.saveData = false;
  //        $("#requirefldmsg").show();
  //        document.getElementById("requirefldmsg").innerHTML = "Please Enter Required Fields in Flight Calculations."
  //        $("#requirefldmsg").delay(2000).hide(1000);
  //        return false;
  //      }

  //      else {
  //        this.saveData = true;
  //        return true;
  //      }
  //    }
  //    //if (this.revenueObj.travelDateTo == "" || this.revenueObj.bookingDateTo == ""
  //    //  || this.revenueObj.selectedToLocationList.length == 0) {
  //    //  this.saveData = false;
  //    //  $("#requirefldmsg").show();
  //    //  document.getElementById("requirefldmsg").innerHTML = "Please Enter Required* Fields."
  //    //  $("#requirefldmsg").delay(2000).hide(1000);
  //    //  return false;
  //    //}

  //  }

  //  catch (e) {
  //    //console.log(e);
  //  }
  //}


  CreateRevenue(model) {

    if (!this.CheckValidations()) {
      return;
    }
    //05-oct-23
    if(this.isDiscount==true){
      if(this.revenueObj.isDiscountSupplierCommission==false && this.revenueObj.isRegularDiscount==false){
        document.getElementById("discountTypeId").innerHTML="Please Select Discount Type";
        setTimeout(() => {
          document.getElementById("discountTypeId").innerHTML = "";
        }, 3000);
        return;
      }
    }
    //end
    if (!this.isValidExpiryDate(this.revenueObj.expiryDate)) {
      document.getElementById("expiryDate").innerHTML = "Future Dates Are Allowed";
      setTimeout(() => {
        document.getElementById("expiryDate").innerHTML = "";
      }, 3000);
      return;
    }
  
    
    for (let i = 0; i < this.flightCalculations.length; i++) {
      if ((this.flightCalculations[i].valueAmount > 0 && this.flightCalculations[i].valuePercent > 0)
        || ((this.revenueObj.oneWayDirection || this.revenueObj.roundTripDirection || this.revenueObj.multiTripDirection) &&
           (this.flightCalculations[i].seg1 < 0 || this.flightCalculations[i].seg2 < 0 || this.flightCalculations[i].seg3 < 0 ||
            this.flightCalculations[i].seg4 < 0 || this.flightCalculations[i].seg5 < 0 || this.flightCalculations[i].seg6 < 0))) {

        if ((this.revenueObj.oneWayDirection || this.revenueObj.roundTripDirection || this.revenueObj.multiTripDirection) &&
           (this.flightCalculations[i].seg1 < 0 || this.flightCalculations[i].seg2 < 0 || this.flightCalculations[i].seg3 < 0 ||
            this.flightCalculations[i].seg4 < 0 || this.flightCalculations[i].seg5 < 0 || this.flightCalculations[i].seg6 < 0)) {
          document.getElementById(`valuePercentmessage${i}`).innerHTML = "Segment values cannot be less than 0";
        } else {
          document.getElementById(`valuePercentmessage${i}`).innerHTML = "Enter Only One Value Percent / Value Amount";
        }

        setTimeout(function () {
          document.getElementById(`valuePercentmessage${i}`).innerHTML = "";

        }, 6000);
        return;
      }
      if (this.flightCalculations[i].selectedRbd.length > 1) {
        for (let k = 0; k < this.flightCalculations[i].selectedRbd.length; k++) {
          if (this.flightCalculations[i].selectedRbd[k] == "ALL") {
            document.getElementById(`valuePercentmessage${i}`).innerHTML = "Already ALL rbd selected you do not Select Another One";

            setTimeout(function () {
              document.getElementById(`valuePercentmessage${i}`).innerHTML = "";

            }, 9000);
            return;
          }
        }

      }
      else {
        this.saveData = true;

      }
    }
    //if (this.revenueObj.selectedValidatingAirlineList.length == 0) this.revenueObj.selectedValidatingAirlineList = [];
    let baseAgency = "";
    if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
      let userId = Number(localStorage.getItem("UserId"))
      if (userId != 0) {
        /*if (this.CheckValiations()) {*/
        if (localStorage.getItem("AgencyId") != undefined &&
          localStorage.getItem("AgencyId") != null && localStorage.getItem("AgencyId") != "")
          this.revenueObj.baseRuleAgency = localStorage.getItem("AgencyId");

        //this.revenueObj.baseRuleAgency = baseAgency;
        if (this.revenueObj.selectedSuppliersList.length > 0 && this.revenueObj.selectedOficeIdsList.length > 0) {
          for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
            for (let j = 0; j < this.revenueObj.selectedOficeIdsList.length; j++) {
              if (this.supplier_oficeIdData[i].uniquekey == this.revenueObj.selectedOficeIdsList[j]) {
                let obj = new RevenueManagementSupplierFlights;
                obj.officeId = this.supplier_oficeIdData[i].officeId;
                obj.supplierId = this.supplier_oficeIdData[i].supplierId;
                this.revenueObj.suppliersData.push(obj);
                break;
              }
            }
          }
        }
        else if (this.revenueObj.selectedSuppliersList.length > 0) {
          for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
            let obj = new RevenueManagementSupplierFlights;
            obj.officeId = '*';
            obj.supplierId = this.supplier_oficeIdData[i].supplierId;
            this.revenueObj.suppliersData.push(obj);
            break;
          }

        }
        if (this.revenueObj.isValidatingAirline == true) {
          for (let i = 0; i < this.selectedValidatingAirline.length; i++) {
            let obj = new RevenueManagement_AirlineFlight();
            obj.airlineTypeId = AirlineControlType.validatingAirline;
            obj.airlineId = this.selectedValidatingAirline[i];
            this.revenueObj.airlineFlightData.push(obj);
          }
        }
        if (this.revenueObj.isMarketingAirline == true) {
          for (let i = 0; i < this.selectedMarkitingAirline.length; i++) {
            let obj = new RevenueManagement_AirlineFlight();
            obj.airlineTypeId = AirlineControlType.marketingAirline;
            obj.airlineId = this.selectedMarkitingAirline[i];
            this.revenueObj.airlineFlightData.push(obj);
          }
        }

        if (this.revenueObj.isOperatingAirline == true) {
          for (let i = 0; i < this.selectedOperatingAirline.length; i++) {
            let obj = new RevenueManagement_AirlineFlight();
            obj.airlineTypeId = AirlineControlType.operatingAirline;
            obj.airlineId = this.selectedOperatingAirline[i];
            this.revenueObj.airlineFlightData.push(obj);
          }
        }
        if (this.revenueObj.isLocation == true) {
          for (let i = 0; i < this.selectedFromLocation.length; i++) {
            for (let j = 0; j < this.selectedToLocation.length; j++) {
              if (this.selectedVIALocation.length > 0) {
                for (let k = 0; k < this.selectedVIALocation.length; k++) {
                  let item = new RevenueManagementFlightLocationProperties();
                  item.fromLocation = this.selectedFromLocation[i];
                  item.toLocation = this.selectedToLocation[j];
                  item.viaLocation = this.selectedVIALocation[k];
                  item.isIncluded = true;
                  this.revenueObj.flightLocationDataIncluded.push(item);
                }
              }
              else {
                let item = new RevenueManagementFlightLocationProperties();
                item.fromLocation = this.selectedFromLocation[i];
                item.toLocation = this.selectedToLocation[j];
                item.viaLocation = "";
                item.isIncluded = true;
                this.revenueObj.flightLocationDataIncluded.push(item);
              }
            }
          }

          for (let i = 0; i < this.excludedFromLocation.length; i++) {
            for (let j = 0; j < this.excludedToLocation.length; j++) {
              if (this.excludedVIALocation.length > 0) {
                for (let k = 0; k < this.excludedVIALocation.length; k++) {
                  let item = new RevenueManagementFlightLocationProperties();
                  item.fromLocation = this.excludedFromLocation[i];
                  item.toLocation = this.excludedToLocation[j];
                  item.viaLocation = this.excludedVIALocation[k];
                  item.isIncluded = false;
                  this.revenueObj.flightLocationDataExcluded.push(item);
                }
              }
              else {
                let item = new RevenueManagementFlightLocationProperties();
                item.fromLocation = this.excludedFromLocation[i];
                item.toLocation = this.excludedToLocation[j];
                item.viaLocation = "";
                item.isIncluded = false;
                this.revenueObj.flightLocationDataExcluded.push(item);
              }
            }
          }
        }
        if (this.flightCalculations.length > 0) {
          for (let i = 0; i < this.flightCalculations.length; i++) {
            let item = this.flightCalculations[i];
            item.rbd = item.selectedRbd.toString();
            item.passengerType = this.flightCalculations[i].passengerType;
            this.revenueObj.flightCalaculationData.push(item);
          }
        }
        if (this.showCountryDropdown) {
          this.revenueObj.flightLocationCountryForInsurance.fromCountryCode = this.selectedFromCountry;
          this.revenueObj.flightLocationCountryForInsurance.toCountryCode = this.selectedToCountry;
        }
        if (this.revenueObj.groupRevenueName != null && this.revenueObj.groupRevenueName.length == 0){
          this.revenueObj.groupRevenueName = null;
        }
        this.revenueObj.creationUser = userId;
        this.revenueService.CreateRevenueManagement(this.revenueObj).subscribe((data) => {
          if (data != 0)
            this.router.navigateByUrl('/revenueManagementList')
          else {

            this.FallSuccess.open(model, {

              /* windowClass: "searchpassengerpopupmodal"*/
              windowClass: "alertpopupmodal"
            })

            //$("#lblerrormsg").show();
            //document.getElementById("lblerrormsg").innerHTML = "Something Went Wrong."
            //$("#lblerrormsg").delay(5000).hide(1000);

            return false;
          }
        })

      }
    }

  }

  UpdateRevenue(model) {
    if (!this.CheckValidations()) {
      return;
    }
        //05-oct-23
        if(this.isDiscount==true){
          if(this.revenueObj.isDiscountSupplierCommission==false && this.revenueObj.isRegularDiscount==false){
            document.getElementById("discountTypeId").innerHTML="Please Select Discount Type";
            setTimeout(() => {
              document.getElementById("discountTypeId").innerHTML = "";
            }, 3000);
            return;
          }
        }
        //end
    if (!this.isValidExpiryDate(this.revenueObj.expiryDate)) {
      document.getElementById("expiryDate").innerHTML = "Future Dates Are Allowed";
      setTimeout(() => {
        document.getElementById("expiryDate").innerHTML = "";
      }, 3000);
      return;
    }
    for (let i = 0; i < this.flightCalculations.length; i++) {
      if ((this.flightCalculations[i].valueAmount > 0 && this.flightCalculations[i].valuePercent > 0)
        || ((this.revenueObj.oneWayDirection || this.revenueObj.roundTripDirection || this.revenueObj.multiTripDirection) &&
           (this.flightCalculations[i].seg1 < 0 || this.flightCalculations[i].seg2 < 0 || this.flightCalculations[i].seg3 < 0 ||
            this.flightCalculations[i].seg4 < 0 || this.flightCalculations[i].seg5 < 0 || this.flightCalculations[i].seg6 < 0))) {

        if ((this.revenueObj.oneWayDirection || this.revenueObj.roundTripDirection || this.revenueObj.multiTripDirection) &&
           (this.flightCalculations[i].seg1 < 0 || this.flightCalculations[i].seg2 < 0 || this.flightCalculations[i].seg3 < 0 ||
            this.flightCalculations[i].seg4 < 0 || this.flightCalculations[i].seg5 < 0 || this.flightCalculations[i].seg6 < 0)) {
          document.getElementById(`valuePercentmessage${i}`).innerHTML = "Segment values cannot be less than 0";
        } else {
          document.getElementById(`valuePercentmessage${i}`).innerHTML = "Enter Only One Value Percent / Value Amount";
        }

        setTimeout(function () {
          document.getElementById(`valuePercentmessage${i}`).innerHTML = "";

        }, 6000);
        return;
      }
      if (this.flightCalculations[i].selectedRbd.length > 1) {
        for (let k = 0; k < this.flightCalculations[i].selectedRbd.length; k++) {
          if (this.flightCalculations[i].selectedRbd[k] == "ALL") {
            document.getElementById(`valuePercentmessage${i}`).innerHTML = "Already ALL rbd selected you do not Select Another One";

            setTimeout(function () {
              document.getElementById(`valuePercentmessage${i}`).innerHTML = "";

            }, 9000);
            return;
          }
        }

      }
      else {
        this.saveData = true;

      }
    }
    let existingIncludedMap = new Map<string, number>();
    this.revenueObj.flightLocationDataIncluded.forEach(x => {
      existingIncludedMap.set(`${x.fromLocation}|${x.toLocation}|${x.viaLocation}`, x.flightLocationId);
    });
    let existingExcludedMap = new Map<string, number>();
    this.revenueObj.flightLocationDataExcluded.forEach(x => {
      existingExcludedMap.set(`${x.fromLocation}|${x.toLocation}|${x.viaLocation}`, x.flightLocationId);
    });

    this.revenueObj.suppliersData = [];
    this.revenueObj.airlineFlightData = [];
    this.revenueObj.flightLocationDataIncluded = [];
    this.revenueObj.flightLocationDataExcluded = [];
    this.revenueObj.flightCalaculationData = [];
    if (this.revenueObj.selectedSuppliersList.length > 0 && this.revenueObj.selectedOficeIdsList.length > 0) {

      for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
        for (let j = 0; j < this.revenueObj.selectedOficeIdsList.length; j++) {
          if (this.supplier_oficeIdData[i].uniquekey == this.revenueObj.selectedOficeIdsList[j]) {
            let obj = new RevenueManagementSupplierFlights;
            obj.officeId = this.supplier_oficeIdData[i].officeId;
            obj.supplierId = this.supplier_oficeIdData[i].supplierId;
            this.revenueObj.suppliersData.push(obj);
            break;
          }
        }
      }
    }
    if (this.revenueObj.isValidatingAirline == true) {

      for (let i = 0; i < this.selectedValidatingAirline.length; i++) {
        let obj = new RevenueManagement_AirlineFlight();
        obj.airlineTypeId = 1;
        obj.airlineId = this.selectedValidatingAirline[i];
        this.revenueObj.airlineFlightData.push(obj);
      }
    }
    if (this.revenueObj.isMarketingAirline == true) {
      for (let i = 0; i < this.selectedMarkitingAirline.length; i++) {
        let obj = new RevenueManagement_AirlineFlight();
        obj.airlineTypeId = 2;
        obj.airlineId = this.selectedMarkitingAirline[i];
        this.revenueObj.airlineFlightData.push(obj);
      }
    }

    if (this.revenueObj.isOperatingAirline == true) {
      for (let i = 0; i < this.selectedOperatingAirline.length; i++) {
        let obj = new RevenueManagement_AirlineFlight();
        obj.airlineTypeId = 3;
        obj.airlineId = this.selectedOperatingAirline[i];
        this.revenueObj.airlineFlightData.push(obj);
      }
    }
    if (this.revenueObj.isLocation == true) {
      for (let i = 0; i < this.selectedFromLocation.length; i++) {
        for (let j = 0; j < this.selectedToLocation.length; j++) {
          if (this.selectedVIALocation.length > 0) {
            for (let k = 0; k < this.selectedVIALocation.length; k++) {
              let item = new RevenueManagementFlightLocationProperties();
              item.fromLocation = this.selectedFromLocation[i];
              item.toLocation = this.selectedToLocation[j];
              if (this.selectedVIALocation[k] != undefined)
                item.viaLocation = this.selectedVIALocation[k];
              else
                item.viaLocation = "";
              item.isIncluded = true;
              let key = `${item.fromLocation}|${item.toLocation}|${item.viaLocation}`;
              if (existingIncludedMap.has(key)) {
                item.flightLocationId = existingIncludedMap.get(key);
              }
              this.revenueObj.flightLocationDataIncluded.push(item);
            }
          }
          else {
            let item = new RevenueManagementFlightLocationProperties();
            item.fromLocation = this.selectedFromLocation[i];
            item.toLocation = this.selectedToLocation[j];
            item.viaLocation = "";
            item.isIncluded = true;
            let key = `${item.fromLocation}|${item.toLocation}|${item.viaLocation}`;
            if (existingIncludedMap.has(key)) {
              item.flightLocationId = existingIncludedMap.get(key);
            }
            this.revenueObj.flightLocationDataIncluded.push(item);
          }
        }
      }

      for (let i = 0; i < this.excludedFromLocation.length; i++) {
        for (let j = 0; j < this.excludedToLocation.length; j++) {
          if (this.excludedVIALocation.length > 0) {
            for (let k = 0; k < this.excludedVIALocation.length; k++) {
              let item = new RevenueManagementFlightLocationProperties();
              item.fromLocation = this.excludedFromLocation[i];
              item.toLocation = this.excludedToLocation[j];
              if (this.excludedVIALocation[k] != undefined)
                item.viaLocation = this.excludedVIALocation[k];
              else
                item.viaLocation = "";
              item.isIncluded = false;
              let key = `${item.fromLocation}|${item.toLocation}|${item.viaLocation}`;
              if (existingExcludedMap.has(key)) {
                item.flightLocationId = existingExcludedMap.get(key);
              }
              this.revenueObj.flightLocationDataExcluded.push(item);
            }
          }
          else {
            let item = new RevenueManagementFlightLocationProperties();
            item.fromLocation = this.excludedFromLocation[i];
            item.toLocation = this.excludedToLocation[j];
            item.viaLocation = "";
            item.isIncluded = false;
            let key = `${item.fromLocation}|${item.toLocation}|${item.viaLocation}`;
            if (existingExcludedMap.has(key)) {
              item.flightLocationId = existingExcludedMap.get(key);
            }
            this.revenueObj.flightLocationDataExcluded.push(item);
          }
        }
      }
    }
    if (this.flightCalculations.length > 0) {
      for (let i = 0; i < this.flightCalculations.length; i++) {

        let item = this.flightCalculations[i];
        item.rbd = item.selectedRbd.toString();
        item.revenueCalculationId = 0;
        item.revenueId = 0;
        this.revenueObj.flightCalaculationData.push(item);
      }
    }
    if (this.showCountryDropdown) {
      this.revenueObj.flightLocationCountryForInsurance.fromCountryCode = this.selectedFromCountry;
      this.revenueObj.flightLocationCountryForInsurance.toCountryCode = this.selectedToCountry;
    }
    // from here
    let baseAgency = "";
    if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
      let userId = Number(localStorage.getItem("UserId"))
      if (userId != 0) {
        /*if (this.CheckValiations()) {*/
        if (localStorage.getItem("AgencyId") != undefined &&
          localStorage.getItem("AgencyId") != null && localStorage.getItem("AgencyId") != "")
          baseAgency = localStorage.getItem("AgencyId");

        this.revenueObj.baseRuleAgency = baseAgency;
        this.revenueObj.modifyUser = userId;
        
        this.revenueService.UpdateRevenueManagement(this.revenueObj).subscribe((data) => {

          if (data != false)
            this.router.navigateByUrl('/revenueManagementList')
          else {
            this.FallSuccess.open(model, {

              /* windowClass: "searchpassengerpopupmodal"*/
              windowClass: "alertpopupmodal"
            })
            //$("#lblerrormsg").show();
            //document.getElementById("lblerrormsg").innerHTML = "Something Went Wrong."
            //$("#lblerrormsg").delay(5000).hide(1000);
            return false;
          }

        })
      }
    }





  }


  SaveData(model) {
    try {
      if (this.ticketRevenue) {
        this.revenueObj.requestTypeID = 1;
      }
      else if (this.voidRevenue) {
        this.revenueObj.requestTypeID = 2;
      }
      else if (this.refundRevenue) {
        this.revenueObj.requestTypeID = 3;
      }
      else if (this.importRevenue) {
        this.revenueObj.requestTypeID = 4;
      }
      /*this.revenueObj.requestTypeID = 1;*/
      if (this.revenueObj.revenueId == 0 || this.revenueObj.revenueId == undefined
        || this.revenueObj.revenueId == null) {

        this.CreateRevenue(model);

      }

      else {
        this.UpdateRevenue(model);

      }

    }

    catch (e) {

    }
  }

  chkofc(e) {
    //const inp = document.getElementById("#abc");
    //inp.addEventListener("input", function () {
    //  //this.revenueObj.isOficeId = true;
    //  alert('i am focused');
    //});
    if (e.target.value == "") {
      this.revenueObj.isOficeId = false;
    } else { this.revenueObj.isOficeId = true; }

  }
  trvlchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isTravelDate = false;
    } else {
      this.revenueObj.isTravelDate = true;
    }

  }
  bkchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isBookingDate = false;
    } else {
      this.revenueObj.isBookingDate = true;
    }

  }
  lcchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isLocation = false;
    } else {
      this.revenueObj.isLocation = true;
    }

  }
  //selectedFromLocations(e) {
  //  if (e.target.value == "") {
  //    this.revenueObj.isLocation = false;
  //  } else if(e.target.value){
  //    this.revenueObj.isLocation = true;
  //  }
  //}
  valchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isValidatingAirline = false;
    } else {
      this.revenueObj.isValidatingAirline = true;
    }
  }

  validatechk() {

    //const inval = document.querySelector("#iam");
    //if (inval.nodeValue == null && inval.nodeValue=="") {
    //  this.revenueObj.isValidatingAirline = false;
    //} else {
    //  this.revenueObj.isValidatingAirline = true;
    //}
    //Adeel changes start
    this.selectedMarkitingAirline = this.selectedValidatingAirline;
    this.selectedOperatingAirline = this.selectedValidatingAirline;
    this.revenueObj.isMarketingAirline = true;
    this.revenueObj.isOperatingAirline = true;
    //end
  
    if (this.selectedValidatingAirline.length > 0) {
      this.revenueObj.isValidatingAirline = true;
    } else {
      this.revenueObj.isValidatingAirline = false;
    }
  
  }
  markchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isMarketingAirline = false;
    } else {
      this.revenueObj.isMarketingAirline = true;
    }

  }
  marketingchk() {

    if (this.selectedMarkitingAirline.length > 0) {
      this.revenueObj.isMarketingAirline = true;
    } else {
      this.revenueObj.isMarketingAirline = false;
    }
  }
  operchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isOperatingAirline = false;
    } else {
      this.revenueObj.isOperatingAirline = true;
    }

  }
  operatingchk() {

    if (this.selectedOperatingAirline.length > 0) {
      this.revenueObj.isOperatingAirline = true;
    } else {
      this.revenueObj.isOperatingAirline = false;
    }
  }
  Cancel() {
    this.router.navigateByUrl('/revenueManagementList');
  }


  CheckValidations(): boolean {
    try {
      //add
      if (this.revenueObj.name == undefined || this.revenueObj.name == "") {
        document.getElementById("messagename").innerHTML = "Required Name";
        document.getElementById("name").classList.add("newRequired-BoxColor");
        setTimeout(function () {
          document.getElementById("messagename").innerHTML = "";
          document.getElementById("name").classList.remove("newRequired-BoxColor");
        }, 6000);
        return false;
      }
      if (this.revenueObj.agencyBranchList.length < 1) {
        document.getElementById("messageagency").innerHTML = "Required Agency";
        document.getElementById("agencybranch").classList.add("newRequired-BoxColor");
        setTimeout(function () {
          document.getElementById("messageagency").innerHTML = "";
          document.getElementById("agencybranch").classList.remove("newRequired-BoxColor");
        }, 6000);
        return false;
      }
      if (this.revenueObj.expiryDate == undefined || this.revenueObj.expiryDate == "") {
        document.getElementById("messageexpiryDate").innerHTML = "Required Date";
        document.getElementById("expiryDate").classList.add("newRequired-BoxColor");
        setTimeout(function () {
          document.getElementById("messageexpiryDate").innerHTML = "";
          document.getElementById("expiryDate").classList.remove("newRequired-BoxColor");
        }, 6000);
        return false;
      }
      if (this.revenueObj.selectedSuppliersList == undefined || this.revenueObj.selectedSuppliersList.length==0 || this.revenueObj.selectedSuppliersList.length == 0) {
        document.getElementById("messagesupplierd").innerHTML = "Required Supplier";
        document.getElementById("supplierd").classList.add("newRequired-BoxColor");
        setTimeout(function () {
          document.getElementById("messagesupplierd").innerHTML = "";
          document.getElementById("supplierd").classList.remove("newRequired-BoxColor");
        }, 6000);
        return false;
      }
      if (this.revenueObj.selectedOficeIdsList.length == 0 || this.revenueObj.selectedOficeIdsList.length ==0) {
        document.getElementById("messageisOficeId").innerHTML = "Required OfficeID";
        document.getElementById("abc").classList.add("newRequired-BoxColor");
        setTimeout(function () {
          document.getElementById("messageisOficeId").innerHTML = "";
          document.getElementById("abc").classList.remove("newRequired-BoxColor");
        }, 6000);
        return false;
      }
      if (this.revenueObj.isOficeId == undefined || this.revenueObj.isOficeId == false) {
        document.getElementById("messageisOficeId").innerHTML = "Required OfficeID CheckBox";
        document.getElementById("checkoffice").classList.add("newRequired-BoxColor");
        setTimeout(function () {
          document.getElementById("messageisOficeId").innerHTML = "";
          document.getElementById("checkoffice").classList.remove("newRequired-BoxColor");
        }, 6000);
        return false;
      }
      if (this.revenueObj.applyChildAgency == false && this.revenueObj.applyChildBranches == false && this.revenueObj.applyHO == false) {
        document.getElementById("messageApplyOn").innerHTML = "Required Minimum one CheckBox";

        setTimeout(function () {
          document.getElementById("messageApplyOn").innerHTML = "";

        }, 6000);
        return false;
      }
      if (this.revenueObj.type == undefined || this.revenueObj.type == "" || this.revenueObj.type == null) {
        document.getElementById("messagetypesefe").innerHTML = "Required Type";

        setTimeout(function () {
          document.getElementById("messagetypesefe").innerHTML = "";

        }, 6000);
        return false;
      }
      if (this.revenueObj.appliesOn.length == 0) {
        document.getElementById("messageApplied").innerHTML = "Required Applied";

        setTimeout(function () {
          document.getElementById("messageApplied").innerHTML = "";

        }, 6000);
        return false;
      }
      if (this.revenueObj.selectedSuppliersList != undefined) {
        //if (this.revenueObj.travelDateFrom.length == 0) {
        //  document.getElementById("travelrequiredfrom").innerHTML = '*From Date Required';
        //  this.reuiredValidate = false;
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.revenueObj.travelDateTo.length == 0) {
        //  document.getElementById("travelrequiredto").innerHTML = '*To Date Required';
        //  this.reuiredValidate = false;
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.revenueObj.bookingDateFrom.length == 0) {
        //  document.getElementById("bookingdateform").innerHTML = '*From Date Required';
        //  this.reuiredValidate = false;
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.revenueObj.bookingDateTo.length == 0) {
        //  document.getElementById("bookingdateto").innerHTML = '*To Date Required';
        //  this.reuiredValidate = false;
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.selectedFromLocation.length == 0) {
        //  document.getElementById("locationdateform").innerHTML = '*Required to';
        //  this.reuiredValidate = false;
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.selectedToLocation.length == 0) {
        //  document.getElementById("locationdateto").innerHTML = '*Required from';
        //  this.reuiredValidate = false;
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.selectedVIALocation.length == 0) {
        //  document.getElementById("locationdatetovia").innerHTML = '*Required via';
        //  this.reuiredValidate = false;
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.excludedToLocation.length == 0) {

        //  this.reuiredValidate = false;
        //  document.getElementById("locationdatetoexclusion").innerHTML = '*Required to';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.excludedFromLocation.length == 0) {
        //  this.reuiredValidate = false;
        //  document.getElementById("locationdateformexclusion").innerHTML = '*Required from';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.excludedVIALocation.length == 0) {
        //  this.reuiredValidate = false;
        //  document.getElementById("locationdateviaexclusion").innerHTML = '*Required via';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.revenueObj.isDirection == false) {
        //  this.reuiredValidate = false;
        //  document.getElementById("directionrequired").innerHTML = '*Direction Required';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.revenueObj.isValidatingAirline == false) {
        //  this.reuiredValidate = false;
        //  document.getElementById("validateairrequired").innerHTML = '*Airline Required';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}

        //if (this.revenueObj.isMarketingAirline == false) {
        //  this.reuiredValidate = false;
        //  document.getElementById("marketingrequired").innerHTML = '*Marketing Required';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.revenueObj.isOperatingAirline == false) {
        //  document.getElementById("opertaingrequired").innerHTML = '*Operating Required';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";

        //}
        //if (this.revenueObj.isTourCode == false) {
        //  document.getElementById("tourrequired").innerHTML = '*Tour Required';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  //var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //countrys.style.boxShadow = "0 0 3px red";
        //  return
        //}
        //if (this.revenueObj.selectionType == 0) {
        //  document.getElementById("dblTyperequired").innerHTML = '*Selection Type Required';
        //  //var country = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  //country.style.borderColor = "red";
        //  ////var countrys = document.querySelector(".countryrequired1") as HTMLInputElement;
        //  ////countrys.style.boxShadow = "0 0 3px red";

        //}
        //  if (this.revenueObj.type == "" || this.revenueObj.name == "" || this.revenueObj.agencyId_BranchId == ""
        //    || (this.revenueObj.selectedSuppliersList.length == 0)) {
        //    this.saveData = false;
        //    $("#requirefldmsg").show();
        //    document.getElementById("requirefldmsg").innerHTML = "Please Select Suppliers."
        //    $("#requirefldmsg").delay(2000).hide(1000);
        //    return false;
        //  }
        //}
        //if (this.revenueObj.travelDateFrom.length > 0 && this.revenueObj.travelDateTo == "") {
        //  this.saveData = false;
        //  $("#requirefldmsg").show();
        //  document.getElementById("requirefldmsg").innerHTML = "Please Select Travel Dates."
        //  $("#requirefldmsg").delay(2000).hide(1000);
        //  return false;
        //}
        //if (this.revenueObj.bookingDateFrom.length > 0 && this.revenueObj.bookingDateTo == "") {
        //  this.saveData = false;
        //  $("#requirefldmsg").show();
        //  document.getElementById("requirefldmsg").innerHTML = "Please Select Booking Dates."
        //  $("#requirefldmsg").delay(2000).hide(1000);
        //  return false;
        //}
        //if (this.selectedFromLocation.length > 0 && this.selectedToLocation.length == 0) {
        //  this.saveData = false;
        //  $("#requirefldmsg").show();
        //  document.getElementById("requirefldmsg").innerHTML = "Please Select To and From Location."
        //  $("#requirefldmsg").delay(2000).hide(1000);
        //  return false;
        //}
        if (this.revenueObj.isTravelDate == true) {
          if (this.revenueObj.travelDateFrom.length <= 0) {
            document.getElementById("travelrequiredfrom").innerHTML = "Required From";

            setTimeout(function () {
              document.getElementById("travelrequiredfrom").innerHTML = "";

            }, 6000);
            return false;
          }
          if (this.revenueObj.travelDateTo.length <= 0) {
            document.getElementById("travelrequiredto").innerHTML = "Required To";

            setTimeout(function () {
              document.getElementById("travelrequiredto").innerHTML = "";

            }, 6000);
            return false;
          }


          if (this.revenueObj.travelDateFrom.length > 0 && this.revenueObj.travelDateTo == "") {
            document.getElementById("travelrequiredto").innerHTML = "Required To";

            setTimeout(function () {
              document.getElementById("travelrequiredto").innerHTML = "";

            }, 6000);
            return false;
          }
          if (this.revenueObj.travelDateTo.length > 0 && this.revenueObj.travelDateFrom == "") {
            document.getElementById("travelrequiredfrom").innerHTML = "Required From";

            setTimeout(function () {
              document.getElementById("travelrequiredfrom").innerHTML = "";

            }, 6000);
            return false;
          }
          if (this.revenueObj.travelDateFrom.length > 0 && this.revenueObj.travelDateTo.length > 0) {
            if (this.revenueObj.travelDateFrom > this.revenueObj.travelDateTo) {
              document.getElementById("travelrequiredfrom").innerHTML = "Carefully select From Or To Date";

              setTimeout(function () {
                document.getElementById("travelrequiredfrom").innerHTML = "";

              }, 6000);
              return false;
            }
          }
        }
        if (this.revenueObj.isBookingDate == true) {
          if (this.revenueObj.bookingDateFrom.length <= 0) {
            document.getElementById("bookingdateform").innerHTML = "Required From";

            setTimeout(function () {
              document.getElementById("bookingdateform").innerHTML = "";

            }, 6000);
            return false;
          }
          if (this.revenueObj.bookingDateTo.length <= 0) {
            document.getElementById("bookingdateto").innerHTML = "Required To";

            setTimeout(function () {
              document.getElementById("bookingdateto").innerHTML = "";

            }, 6000);
            return false;
          }



          if (this.revenueObj.bookingDateFrom.length > 0 && this.revenueObj.bookingDateTo == "") {
            document.getElementById("bookingdateto").innerHTML = "Required To";

            setTimeout(function () {
              document.getElementById("bookingdateto").innerHTML = "";

            }, 6000);
            return false;
          }
          if (this.revenueObj.bookingDateTo.length > 0 && this.revenueObj.bookingDateFrom == "") {
            document.getElementById("bookingdateform").innerHTML = "Required From";

            setTimeout(function () {
              document.getElementById("bookingdateform").innerHTML = "";

            }, 6000);
            return false;
          }
          if (this.revenueObj.bookingDateFrom.length > 0 && this.revenueObj.bookingDateTo.length > 0) {
            if (this.revenueObj.bookingDateFrom > this.revenueObj.bookingDateTo) {
              document.getElementById("bookingdateform").innerHTML = "Carefully select From Or To Date";

              setTimeout(function () {
                document.getElementById("bookingdateform").innerHTML = "";

              }, 6000);
              return false;
            }
          }
        }


        if (this.flightCalculations.length < 1
          || this.flightCalculations.length == null) {
          this.saveData = false;

          document.getElementById("requirefldmsg").innerHTML = "Please Enter Calculation Data";

          setTimeout(function () {
            document.getElementById("requirefldmsg").innerHTML = "";

          }, 6000);
          return false;

        }

      }
      for (let i = 0; i < this.flightCalculations.length; i++) {
        if (this.flightCalculations[i].cabinClass == "" || this.flightCalculations[i].cabinClass == null
          || this.flightCalculations[i].calculatedOn == "" || this.flightCalculations[i].calculatedOn == null
          || this.flightCalculations[i].passengerType.length < 0  || this.flightCalculations[i].passengerType == null
          || this.flightCalculations[i].selectedRbd.length < 1 || this.flightCalculations[i].selectedRbd.length == null
          || (this.flightCalculations[i].valueAmount < 0 && this.flightCalculations[i].valuePercent < 0)
        )
        {
          document.getElementById("requirefldmsg").innerHTML = "Please Enter Calculation Data";

          setTimeout(function () {
            document.getElementById("requirefldmsg").innerHTML = "";

          }, 6000);
          return false;
        }

        else {
          this.saveData = true;
          return true;
        }
      }
      for (let i = 0; i < this.flightCalculations.length; i++) {
        if ((this.flightCalculations[i].valueAmount > 0 && this.flightCalculations[i].valuePercent > 0)) {

          document.getElementById(`valuePercentmessage${i}`).innerHTML = "Enter Only One Value Percent / Value Amount";

          setTimeout(function () {
            document.getElementById(`valuePercentmessage${i}`).innerHTML = "";

          }, 6000);
          return false;
        }

        else {
          this.saveData = true;

        }
      }

      //if (this.revenueObj.travelDateTo == "" || this.revenueObj.bookingDateTo == ""
      //  || this.revenueObj.selectedToLocationList.length == 0) {
      //  this.saveData = false;
      //  $("#requirefldmsg").show();
      //  document.getElementById("requirefldmsg").innerHTML = "Please Enter Required* Fields."
      //  $("#requirefldmsg").delay(2000).hide(1000);
      //  return false;
      //}

    }

    catch (e) {
      //console.log(e);
    }
  }
  valueamountflight: boolean = false;
  valuePercentflight: boolean = false;
  flightvaluesamountchanges(i, param) {
    if (param > 0) {
      var value = document.getElementById(`valuePercent${i}`) as HTMLInputElement;
      value.disabled = true;
      this.flightCalculations[i].valuePercent = 0;

    }
    else {
      var value = document.getElementById(`valuePercent${i}`) as HTMLInputElement;
      value.disabled = false;
      this.flightCalculations[i].valueAmount = 0;
    }

  }
  flightvaluespercentchanges(i, param) {
    if (param > 0) {
      var value = document.getElementById(`valueAmount${i}`) as HTMLInputElement;
      value.disabled = true;
      this.flightCalculations[i].valueAmount = 0;

    }
    else {
      var value = document.getElementById(`valueAmount${i}`) as HTMLInputElement;
      value.disabled = false;
      this.flightCalculations[i].valuePercent = 0;
    }

  }
  rbdselect(i, model) {

    for (let o = 0; o < this.flightCalculations.length; o++) {
      if (o != i) {
        if (this.flightCalculations[o].selectedRbd.length > 0) {
          if (this.flightCalculations[o].passengerType == this.flightCalculations[i].passengerType && this.flightCalculations[o].cabinClass == this.flightCalculations[o].cabinClass) {
            for (let p = 0; p < this.flightCalculations[i].selectedRbd.length; p++) {
              for (let h = 0; h < this.flightCalculations[o].selectedRbd.length; h++) {
                if (this.flightCalculations[i].selectedRbd[p] == this.flightCalculations[o].selectedRbd[h]) {
                  this.flightCalculations[o].selectedRbd = this.flightCalculations[o].selectedRbd.splice(0, h);
                  this.FallSuccess.open(model, {
                    size: 'sm',
                  });
                }
              }
            }
          }

        }
      }
    }

  }
  isValidExpiryDate(dateString) {

    const currentDate = new Date();
    const expDate = new Date(dateString);

    if (expDate < currentDate) {
      return false;
    }
    else {
      const today = new Date(expDate);
      this.minDateto = today.toISOString().split('T')[0];
    }
    return true;

  }
  dateexpvalidate(exp) {
    if (!this.isValidExpiryDate(exp)) {
      document.getElementById("messageexpiryDate").innerHTML = "Future Dates Only";
      setTimeout(() => {
        document.getElementById("messageexpiryDate").innerHTML = "";
      }, 3000);
      return;
    }
  }

  //05-oct-23
  OnDiscountTypeChange = (event: any): void => {
    if (event.target.value == "DiscountSupplierCommission") {
      this.revenueObj.isDiscountSupplierCommission = true;
      this.revenueObj.isRegularDiscount = false;
    }
    else if (event.target.value == "RegularDiscount") {
      this.revenueObj.isDiscountSupplierCommission = false;
      this.revenueObj.isRegularDiscount = true;
    }
  }


  //end

  flightWTHamountchanges(i, param) {
    if (param > 0) {
      var value = document.getElementById(`WTHPercent${i}`) as HTMLInputElement;
      value.disabled = true;
      this.flightCalculations[i].withHoldingTaxPercentage = 0;

    }
    else {
      var value = document.getElementById(`WTHPercent${i}`) as HTMLInputElement;
      value.disabled = false;
      this.flightCalculations[i].withHoldingTaxValue = 0;
    }

  }
  flightWTHpercentchanges(i, param) {
    if (param > 0) {
      var value = document.getElementById(`WTHAmount${i}`) as HTMLInputElement;
      value.disabled = true;
      this.flightCalculations[i].withHoldingTaxValue = 0;

    }
    else {
      var value = document.getElementById(`WTHAmount${i}`) as HTMLInputElement;
      value.disabled = false;
      this.flightCalculations[i].withHoldingTaxPercentage = 0;
    }

  }
  

  onFileChange(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    this.fileName = target.files[0].name;

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      this.data = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // Call bindValues after the file is read and data is set
      this.bindValues();
    };
    reader.readAsBinaryString(target.files[0]);
  }

  bindValues() {
    if (this.data.length === 0) {
      console.log('No file has been uploaded yet.');
      return;
    }

    // Transform rows to columns
    const columns = this.transpose(this.data);

    // Update values for each field only if values are present in the corresponding column
    if (columns[0].slice(1).some(value => value)) {
      this.selectedValidatingAirline = columns[0].slice(1).filter(value => value);  // Remove empty values
    } else {
      this.selectedValidatingAirline = [];
    }

    if (columns[1].slice(1).some(value => value)) {
      this.selectedMarkitingAirline = columns[1].slice(1).filter(value => value);   // Remove empty values
    } else {
      this.selectedMarkitingAirline = [];
    }

    if (columns[2].slice(1).some(value => value)) {
      this.selectedOperatingAirline = columns[2].slice(1).filter(value => value);   // Remove empty values
    } else {
      this.selectedOperatingAirline = [];
    }

    if (
      this.selectedValidatingAirline.length === 0 &&
      this.selectedMarkitingAirline.length === 0 &&
      this.selectedOperatingAirline.length === 0
    ) {
      this.messageservice.add({ severity: 'error', summary: 'Fail', detail: 'There is No Data' });
      console.log('No data');
      return;
    }
    console.log('Values bound successfully.');
  }

  transpose(matrix: any[][]) {
    return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
  }
 
  applyoneatatime(type: string) {
    if (type == "onlyon") {
      if (this.revenueObj.applyonCodeShare && this.revenueObj.applyOnCodeShareOnly) {
        this.revenueObj.applyOnCodeShareOnly = false;
        this.messageservice.add({ severity: 'error', summary: 'Reject', detail: 'Apply only one at a time!' });
      }
    }
    else if (type == "oncode") {
      if (this.revenueObj.applyonCodeShare && this.revenueObj.applyOnCodeShareOnly) {
        this.revenueObj.applyonCodeShare = false;
        this.messageservice.add({ severity: 'error', summary: 'Reject', detail: 'Apply only one at a time!' });
      }
    }
    else if (type == "onlyoninterline") {
      if (this.revenueObj.applyonInterlineFlight && this.revenueObj.applyOnInterlineFlightOnly) {
        this.revenueObj.applyOnInterlineFlightOnly = false;
        this.messageservice.add({ severity: 'error', summary: 'Reject', detail: 'Apply only one at a time!' });
      }
    }
    else if (type == "oninterline") {
      if (this.revenueObj.applyonInterlineFlight && this.revenueObj.applyOnInterlineFlightOnly) {
        this.revenueObj.applyonInterlineFlight = false;
        this.messageservice.add({ severity: 'error', summary: 'Reject', detail: 'Apply only one at a time!' });
      }
    }
  }
}

